<template>
  <div class="background_white pb4">
    <div class="container">
      <h2 class="caps black italic center mt3 pt3 pb1 smaller">{{$store.state.translations.de_lideation_au_deploiement}}</h2>
      <div class="flex flex-wrap">
        <div class="green col-12 sm-col-6 md-col-4" :class="{selected: selectedTile === article.id}" :style="{backgroundImage: 'url(\'' + article.acf.vignette.url + '\')'}" @click="tileClicked(article)" v-for="article in $store.state.articles.filter(a => a.acf.accueil || $route.name === 'portfolio')" :key="article.id">
          <div>
            <div>
              <span v-html="copyright(article.title.rendered)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selectedTile: null,
      timer: null
    }
  },
  methods: {
    tileClicked(article) {
      // if (this.selectedTile === article.id) {
        this.$router.push({name: 'article', params: {id: article.slug}});
      // } else {
      //   this.selectedTile = article.id;
      //   this.timer = setTimeout(() => {this.selectedTile = null;}, 3000);
      // }
    },
    copyright (a) {
      return a.replace(/®/g, '<sup style="line-height: 0;">®</sup>');
    }
  }
};
</script>